import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = unknown, false = anonymous, {} = user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("rp_token");
    if (!t) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("rp_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_otp) {
      // Step 1 succeeded, but 2FA is enabled — caller must complete
      // with `loginOtp` before we hand back a full session.
      return { requires_otp: true, otp_ticket: data.otp_ticket, email };
    }
    localStorage.setItem("rp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginOtp = async ({ email, otp, otp_ticket }) => {
    const { data } = await api.post("/auth/login", {
      email,
      password: "",
      otp,
      otp_ticket,
    });
    localStorage.setItem("rp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("rp_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginOtp, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
